import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import useGetVsic from '../../../../../common/category/useGetVsic'
import useDidUpdateEffect from '../../../../../common/hooks/useDidUpdateEffect'
import {
  getDataAvailability,
  getReportItem,
} from '../../../../../common/order/factSheetReport/store/thunk'
import { SelectCustom } from '../../../../../common/selectCustom'
import {
  resetStoreHeaderCompanyAnalysis,
  selectCompanyInfo,
} from '../../../../../companyAnalysis/common/header/companyInfo/store/slice'
import { getHeaderCompanyAnalysis } from '../../../../../companyAnalysis/common/header/companyInfo/store/thunk'
import { getDefaultVsic } from '../../../../../companyAnalysis/industry/helper'
import { COMPONENTS } from '../../../../../routers/constants'
import { MAIN_SCREEN } from '../../../constant'
import { DEFAULT_INDUSTRY } from '../../../helper/companyAnalysis/industryAnalysis'
import { dataSelectCompanyType } from '../constant'
import classes from '../index.module.scss'
import {
  changeCompanyType,
  changeLoadingDetailTemplate,
  changeValue,
  selectCompanyType,
  selectIsKeepingSetting,
  selectMainScreen,
  selectPanelById,
  selectSettingFs,
  setDefaultYearFinancialAnalysis,
  setNullYearFinancialAnalysis,
} from '../store/slice'
import { getAllPortfolio } from '../store/thunk'
import InputCompany from './InputCompany'
import InputPortfolio from './InputPortfolio'

const PAGE_SIZE = 300
let isMounted = true

const SearchArea = ({ openPopup }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const { organizationId: organizationIdParam } = new Proxy(
    new URLSearchParams(location.search),
    {
      get: (searchParam, prop) => searchParam.get(prop),
    },
  )

  const { vsics } = useGetVsic(true)

  const companyInfo = useSelector(selectCompanyInfo)
  const settingFs = useSelector(selectSettingFs)
  const isKeepingSetting = useSelector(selectIsKeepingSetting)
  const panelById = useSelector(selectPanelById)
  const mainScreen = useSelector(selectMainScreen)
  const companyType = useSelector(selectCompanyType)
  const locale = useSelector((state) => state.i18n.locale)

  useEffect(() => {
    if (companyInfo.organizationId && !companyInfo.allowDynamicReport) {
      dispatch(setNullYearFinancialAnalysis())
      navigate(COMPONENTS.dynamicReport.route)
      dispatch(resetStoreHeaderCompanyAnalysis())
    } else if (companyInfo.organizationId) {
      dispatch(changeLoadingDetailTemplate(true))
      dispatch(changeCompanyType(companyInfo.companyType))
      Object.values(panelById).forEach((item) => {
        if (item.screen === 'industryAnalysis') {
          dispatch(
            changeValue({
              id: item.id,
              key: `setting.${DEFAULT_INDUSTRY}`,
              value: isMounted
                ? panelById[item.id]?.setting?.[DEFAULT_INDUSTRY] ||
                  getDefaultVsic(vsics, companyInfo.mainVsicId).id
                : getDefaultVsic(vsics, companyInfo.mainVsicId).id,
            }),
          )
        }
      })

      isMounted = false
      // End: Set default industry

      const getSettingReport = async () => {
        const payload = await Promise.allSettled([
          dispatch(
            getReportItem({ OrganizationId: companyInfo.organizationId }),
          ).unwrap(),
          dispatch(
            getDataAvailability({
              organizationId: companyInfo.organizationId,
              ...(isKeepingSetting ? settingFs : {}),
            }),
          ).unwrap(),
        ])

        dispatch(changeLoadingDetailTemplate(false))
        dispatch(setDefaultYearFinancialAnalysis(payload[1]?.value))
      }

      getSettingReport()
    } else {
      dispatch(setNullYearFinancialAnalysis())
    }
  }, [companyInfo.organizationId])

  useEffect(() => {
    if (organizationIdParam) {
      if (
        !companyInfo.organizationId ||
        +companyInfo.organizationId !== +organizationIdParam
      ) {
        dispatch(
          getHeaderCompanyAnalysis({ OrganizationId: organizationIdParam }),
        )
      }
    }
  }, [organizationIdParam])

  useDidUpdateEffect(() => {
    if (organizationIdParam) {
      if (
        companyInfo.organizationId ||
        +companyInfo.organizationId === +organizationIdParam
      ) {
        dispatch(
          getHeaderCompanyAnalysis({ OrganizationId: organizationIdParam }),
        )
      }
    }
  }, [locale])

  useEffect(() => {
    dispatch(getAllPortfolio({ PageSize: PAGE_SIZE }))
  }, [locale])

  if (mainScreen === MAIN_SCREEN.COMPANY_ANALYSIS) {
    return (
      <div className={`dFlex ${classes.mt12}`}>
        <SelectCustom
          key={locale}
          data={dataSelectCompanyType}
          activeItem={dataSelectCompanyType.find(
            ({ value }) => value === companyType,
          )}
          chooseItem={openPopup}
          style={{ backgroundColor: '#FFFFFF' }}
          isI18n
        />
        <div className={classes.searchCompanyContainer}>
          <InputCompany />
        </div>
      </div>
    )
  }

  return <InputPortfolio />
}

export default SearchArea
